import Axios, { AxiosRequestConfig } from 'axios';
import { localStorageEnum } from 'types';
import { API_URL } from './constants';

const baseURL = API_URL;

const client = Axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use(
  config => {
    const token = localStorage.getItem(localStorageEnum.token) || '';
    if (token) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: token,
        },
      };
    }
    return config;
  },
  e => Promise.reject(e),
);

export const request = function (options: AxiosRequestConfig) {
  const onSuccess = function (response: any) {
    return response.data;
  };

  const onError = function (error: any) {
    if (error?.response?.data.status_code !== 404) {
      // Request was made but server responded with something
      // other than 2xx OR 404
    } else {
      // Something else happened while setting up the request
      // triggered the error
    }

    return Promise.reject(error.response || error.message);
  };

  return client(options).then(onSuccess).catch(onError);
};

// import { authHeader } from './helpers';
// export class ResponseError extends Error {
//   public response: Response;

//   constructor(response: Response) {
//     super(response.statusText);
//     this.response = response;
//   }
// }
// /**
//  * Parses the JSON returned by a network request
//  *
//  * @param  {object} response A response from a network request
//  *
//  * @return {object}          The parsed JSON from the request
//  */
// function parseJSON(response: Response) {
//   if (response.status === 204 || response.status === 205) {
//     return null;
//   }
//   return response.json();
// }

// /**
//  * Checks if a network request came back fine, and throws an error if not
//  *
//  * @param  {object} response   A response from a network request
//  *
//  * @return {object|undefined} Returns either the response, or throws an error
//  */
// function checkStatus(response: Response) {
//   if (response.status >= 200 && response.status < 300) {
//     return response;
//   }
//   const error = new ResponseError(response);
//   error.response = response;
//   throw error;
// }

// /**
//  * Requests a URL, returning a promise
//  *
//  * @param  {string} url       The URL we want to request
//  * @param  {object} [options] The options we want to pass to "fetch"
//  *
//  * @return {object}           The response data
//  */
// export async function request(
//   url: string,
//   options?: RequestInit,
// ): Promise<{} | { err: ResponseError }> {
//   const fetchResponse = await fetch(url, { ...options, headers: authHeader() });
//   const response = checkStatus(fetchResponse);
//   return parseJSON(response);
// }
